import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { appRoutes } from "src/app/app.routes";
import { AuthService } from "~modules/auth/auth.service";

export const authenticationGuard = async () => {
  const authService: AuthService = inject(AuthService);
  if (await authService.isAuthenticated()) {
    return true;
  } else {
    const router: Router = inject(Router);
    router.navigate([appRoutes.error404]);
    return false;
  }
};
